import React, {
  useState,
} from 'react';
import { usePaginatedQuery, ErrorHandler, InfiniteScrollComponent } from '@playbookux/playbook-web-core';

import {
  GET_ALL_TESTERS,
  DEBOUNCE_TIME,
} from './graphql';
import Tester from './tester';
import withDashboardSidebar from '../../components/with-dashboard-sidebar';
import SearchField from '../../../core/layout-components/search';
import useDebounce from '../../../core/hooks/use-debounce';

import {
  Column,
  Container,
  ContainerMessage,
  Grid,
  Row,
  Title,
  UserComponent,
  Header,
  SearchContainer,
} from './styles';
import DefaultFilterUsers from '../../../core/components/filter-components/default-filter-users';

const columnsTitles = [
  { id: 1, title: '', width: 1 },
  { id: 2, title: 'Name', width: 3 },
  { id: 6, title: '', width: 1 },
];

const LIMIT = 30;

// this screen is to fetch tester guest users.
const Testers = () => {
  const [search, setSearch] = useState('');
  const [debouncedSearch] = useDebounce(() => search, DEBOUNCE_TIME, [search]);
  const [defaultFilters, setDefaultFilters] = useState({
    guest: true,
    status: 'active',
    lastLoginMonths: 12,
  });

  const {
    loading,
    data = {},
    fetchMore,
    hasMore,
    error,
    refetch,
  } = usePaginatedQuery(GET_ALL_TESTERS, {
    variables: {
      limit: LIMIT,
      offset: 0,
      order: 'created_at DESC',
      search: debouncedSearch,
      ...defaultFilters,
    },
  }, {
    dataField: 'users',
  });

  const { users = [], usersCount = 0 } = data;

  const handleSearchChange = (e, { value }) => {
    setSearch(value);
  };

  const onChange = (e, { value }, propertyName) => {
    setDefaultFilters({ ...defaultFilters, [propertyName]: value });
    refetch({ ...defaultFilters, [propertyName]: value });
  };

  if (error) {
    return (
      <ContainerMessage size="18px">
        <ErrorHandler
          error={error}
          defaultMessage="Error while retrieving users."
        />
      </ContainerMessage>
    );
  }

  return (
    <Container>
      <InfiniteScrollComponent
        useWindow
        hasMore={hasMore}
        onLoadMore={fetchMore}
      >
        <UserComponent>
          <Grid stackable columns={6}>
            <Row>
              <Column noPadding width={16}>
                <Header>
                  <Title>
                    {`Testers - ${usersCount} testers`}
                  </Title>
                  <SearchContainer>
                    <SearchField
                      input={{ icon: 'search', iconPosition: 'left' }}
                      placeholder="Search tester"
                      onSearchChange={handleSearchChange}
                      value={search || ''}
                      showNoResults={false}
                      loading={loading && !!search}
                    />
                  </SearchContainer>
                </Header>
              </Column>
            </Row>
            <Row>
              <DefaultFilterUsers
                filterPosition="column"
                defaultFilters={defaultFilters}
                setDefaultFilters={setDefaultFilters}
                onChange={onChange}
              />
            </Row>
            <Row>
              {columnsTitles.map((columnsTitle) => (
                <Column key={columnsTitle.id} weight="500" width={columnsTitle.width}>
                  {columnsTitle.title}
                </Column>
              ))}
            </Row>

            {users.map((user, index) => (
              <Tester index={index} key={user.id} user={user} link={`/testers/${user.id}/employment`} />
            ))}
          </Grid>
        </UserComponent>
      </InfiniteScrollComponent>
    </Container>
  );
};

export default withDashboardSidebar(Testers);
